import { ReloadOutlined, SearchOutlined } from '@ant-design/icons';
import { css } from '@emotion/react';
import {
    Button,
    Col,
    Collapse,
    CollapseProps,
    Form,
    InputNumber,
    Row,
    Select,
    Typography
} from 'antd';
import {
    getListGroupFood,
    getListMaterialFood,
} from '@/redux/slices/food.slice';

import {
    watchListDishAge,
} from '@/redux/slices/dish.slice';

// import {
//     getListFilterDishObject,
//     watchListFilterDish
// } from '@/redux/slices/nutritional-menu-calculator.slice';

import {
    watchListNutritionHealthStatusComboFood,
    watchListNutritionStatusZScoreComboFood,
    watchListPhysicalActivityComboFood,
    watchListGenderComboFood
} from '@/redux/slices/combo-food.slice';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useEffect } from 'react';

export const TargetIndividualSearcher = ({
    handleSearch
}: {
    handleSearch: (values: FilterTargetProfileNutritionalMenuCalculator) => void;
}) => {
    const [form] = Form.useForm();
    const dispatch = useAppDispatch();
    const listDishAge = useAppSelector(watchListDishAge);
    const listNutritionHealthStatusComboFood = useAppSelector(watchListNutritionHealthStatusComboFood);
    const listNutritionStatusZScoreComboFood = useAppSelector(watchListNutritionStatusZScoreComboFood);
    const listPhysicalActivityComboFood = useAppSelector(watchListPhysicalActivityComboFood);
    const listGender = useAppSelector(watchListGenderComboFood);

    const ageDishGroupOptions = listDishAge.map((item) => ({
        value: item.id,
        label: item.name
    }));

    const listNutritionHealthStatusOptions = listNutritionHealthStatusComboFood.map((item) => ({
        value: item.healthStatusId,
        label: item.displayName
    }));

    const listNutritionStatusZScoreOptions = listNutritionStatusZScoreComboFood.map((item) => ({
        value: item.id,
        label: item.description
    }));

    const listPhysicalActivityComboFoodOptions = listPhysicalActivityComboFood.map((item) => ({
        value: item.id,
        label: item.name
    }));

    const listGenderOptions = listGender.map((item) => ({
        value: item.id,
        label: item.name
    }));

    const onSearch = async () => {
        const values = form.getFieldsValue();
        handleSearch(values);
        // await dispatch(getListFilterDishObject(values));
    }

    const handleClear = () => {
        form.resetFields();
    };

    useEffect(() => {
        dispatch(getListMaterialFood());
        dispatch(getListGroupFood());
    }, [dispatch]);

    const items: CollapseProps['items'] = [
        {
            key: '1',
            label: (
                <Typography.Title css={titleStyles} level={5}>
                    Chọn đối tượng xây dựng thực đơn
                </Typography.Title>
            ),
            children: (
                <Form
                    form={form}
                    css={formStyles}
                >
                    <Row gutter={16} align='stretch' className='rowStyle'>
                        <Col span={8} css={filterItem}>
                            <Form.Item
                                label='Đối tượng (Độ tuổi)'
                                name='age'
                                css={customLabel}
                            >
                                <Select
                                    allowClear
                                    showSearch
                                    optionFilterProp="children"
                                    style={{ width: '100%' }}
                                    options={ageDishGroupOptions}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} css={filterItem}>
                            <Form.Item
                                label='Tình trạng sức khỏe'
                                name='healthStatus'
                                css={customLabel}
                            >
                                <Select
                                    mode="multiple"
                                    allowClear
                                    style={{ width: '100%' }}
                                    options={listNutritionHealthStatusOptions}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8} css={filterItem}>
                            <Form.Item
                                label='Giới tính'
                                name='gender'
                                css={customLabel}
                            >
                                <Select
                                    allowClear
                                    options={listGenderOptions} />
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={16} align='stretch' className='rowStyle'>
                        <Col span={8} css={filterItem}>
                            <Form.Item
                                label='Hoạt động thể lực'
                                name='physicalActivity'
                                css={customLabel}
                            >
                                <Select
                                    allowClear
                                    options={listPhysicalActivityComboFoodOptions} />
                            </Form.Item>
                        </Col>
                        <Col span={8} css={filterItem}>
                            <Form.Item
                                label='Cân nặng (kg)'
                                name='weight'
                                css={customLabel}
                            >
                                <Row gutter={8} align="middle">
                                    <Col span={11}>
                                        <Form.Item name="WEIGHT_MIN"
                                            style={{ marginBottom: 0 }}>
                                            <InputNumber min={0} placeholder="" type='number' style={{ width: '100%' }}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={2} style={{ textAlign: "center" }}>-</Col>
                                    <Col span={11}>
                                        <Form.Item name="WEIGHT_MAX" style={{ marginBottom: 0 }}>
                                            <InputNumber min={0} placeholder="" type='number' style={{ width: '100%' }}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form.Item>
                        </Col>
                        <Col span={8} css={filterItem} >
                            <Form.Item
                                label='Tình trạng dinh dưỡng theo Zcores (Cân nặng theo tuổi)'
                                name='healthStatusZCore'
                                css={customLabel}
                                className='zscoreInputStyle'
                            >
                                <Select
                                    allowClear
                                    options={listNutritionStatusZScoreOptions} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row
                        gutter={16}
                        align='middle'
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '1rem'
                        }}
                    >
                        <Button
                            type='default'
                            icon={<ReloadOutlined />}
                            css={resetButton}
                            onClick={handleClear}
                        >
                            Đặt lại
                        </Button>
                        <Button
                            type='primary'
                            icon={<SearchOutlined />}
                            css={searchButton}
                            onClick={onSearch}
                        >
                            Tìm kiếm
                        </Button>
                    </Row>
                </Form>
            )
        }
    ];
    return (
        <Row css={boxStyles} justify='space-between' align='middle'>
            <Collapse
                items={items}
                defaultActiveKey={'1'}
                expandIconPosition={'end'}
                css={collapseStyles}
            />
        </Row>
    );
};

const boxStyles = css`
  padding: 0 1rem;
  background: var(--white-color);
  margin-bottom: 1rem;
  &:nth-of-type(2) {
    padding: 1.6rem 1rem;
  }
  .rowStyle .ant-col-8 {
    display: flex;
    justify-content: center;
    align-items: center;
    .zscoreInputStyle .ant-form-item-control {
       display: flex;
       justify-content: center;
       
    }
  } 
`;

const collapseStyles = css`
  width: 100%;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  background-color: transparent !important;

  .ant-collapse-header {
    width: fit-content;
    border-radius: 0.8rem !important;
    border: none !important;
    padding: 0 !important;

    .ant-collapse-expand-icon {
      align-self: center;
    }
  }

  .ant-collapse-content-box {
    padding: 0 !important;
  }

  .ant-collapse-content {
    border: none !important;
  }
`;

const titleStyles = css`
  margin-bottom: 0 !important;
  font-weight: 700 !important;
`;

const formStyles = css`
  margin-top: 0.5rem;
`;

const filterItem = css`
  display: flex;
  justify-content: start !important;
  gap: 0.5rem;

  label {
    height: 100% !important;
  }

  .ant-form-item-label {
    width: fit-content;
    max-width: 33.33%;
    height: 100% !important;
    text-align: start !important;
    white-space: normal;
    font-size: 14px;
    font-weight: 500;
    word-wrap: break-word;
    word-break: break-word;
  }

  input,
  .ant-select,
  .ant-picker {
    flex: 1;
    min-width: 6rem;
  }

  .ant-form-item-control-input-content>.ant-input {
    height: auto !important;
    font-size: 14px !important;
  }
`;

const customLabel = css`
  .ant-form-item-label > label {
    font-weight: normal !important;

    &::after,
    &::before {
      display: none !important;
    }

    margin: 0 2rem 0 0 !important;
  }

  width: 100%;
  margin-bottom: 0;

  .ant-form-item-label {
    height: unset !important;
  }
`;

const resetButton = css`
  margin-right: 10px;
  color: #007bff;
  border-color: #007bff;
`;

const searchButton = css`
  background: #007bff;
  color: white;
  &:hover {
    background: #0056b3;
  }
`;
